var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":_vm.statusData.color,"title":_vm.statusData.titleMessage}},[_vm._v(_vm._s(_vm.statusData.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }